(function(){
  function ready(fn){
    if(document.readyState !== 'loading'){ fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }
  ready(function(){
    var rails = document.querySelectorAll('.ovys-hero-rail');
    for(var ri = 0; ri < rails.length; ri++){ initRail(rails[ri]); }
  });

  function initRail(rail){
    if(!rail || rail.getAttribute('data-ovys-hero-init') === '1') return;
    if(rail.children.length < 2) return;
    rail.setAttribute('data-ovys-hero-init', '1');

    var dotsWrap = null;
    var sib = rail.nextElementSibling;
    while(sib){ if(sib.classList && sib.classList.contains('ovys-hero-dots')){ dotsWrap = sib; break; } sib = sib.nextElementSibling; }

    var vp = document.createElement('div');
    vp.className = 'ovys-hero-viewport';
    rail.parentNode.insertBefore(vp, rail);
    vp.appendChild(rail);

    /* 実スライドの前後に、余裕をもって2枚ずつクローンを置く（ドラッグ中に端が見えないように） */
    var N = rail.children.length;
    var originals = [].slice.call(rail.children);
    var pad = 2;
    var i, c;
    for(i = 0; i < pad; i++){
      c = originals[N - 1 - i].cloneNode(true); c.setAttribute('data-ovys-clone', '1');
      rail.insertBefore(c, rail.firstChild);
    }
    for(i = 0; i < pad; i++){
      c = originals[i].cloneNode(true); c.setAttribute('data-ovys-clone', '1');
      rail.appendChild(c);
    }
    var slides = [].slice.call(rail.children);
    var OFFSET = pad;
    var idx = OFFSET;
    var x = 0;

    var imgs = rail.querySelectorAll('img');
    for(var k = 0; k < imgs.length; k++){ if(imgs[k].decode){ imgs[k].decode().catch(function(){}); } }

    function slideStep(){ return slides[OFFSET].offsetWidth + 8; }
    function loopSpan(){ return slideStep() * N; }
    function centerFor(i){ var s = slides[i]; return -(s.offsetLeft + s.offsetWidth / 2 - vp.clientWidth / 2); }
    function setX(v, anim){
      x = v;
      rail.style.transition = anim ? 'transform .34s cubic-bezier(.22,.61,.36,1)' : 'none';
      rail.style.transform = 'translate3d(' + v + 'px,0,0)';
    }
    function realIndex(){ var r = (idx - OFFSET) % N; if(r < 0){ r = r + N; } return r; }
    function normalizeIdx(){
      /* idx を実スライド範囲 [OFFSET, OFFSET+N-1] に収め、x も同じ見た目のままループ内へ */
      var changed = false;
      while(idx < OFFSET){ idx = idx + N; x = x - loopSpan(); changed = true; }
      while(idx > OFFSET + N - 1){ idx = idx - N; x = x + loopSpan(); changed = true; }
      if(changed){ setX(x, false); }
    }

    var dots = [];
    if(dotsWrap){
      for(i = 0; i < N; i++){
        (function(ri){
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', (ri + 1) + '');
          b.addEventListener('click', function(){ go(ri + OFFSET, true); });
          dotsWrap.appendChild(b);
          dots.push(b);
        })(i);
      }
    }
    function updateDots(){ var cur = realIndex(); for(var j = 0; j < dots.length; j++){ dots[j].classList.toggle('is-active', j === cur); } }

    function go(i, anim){ idx = i; setX(centerFor(i), anim); updateDots(); }

    /* スナップアニメ完了後、実スライド範囲外にいたら見た目そのままで範囲内へ戻す（無限ループ） */
    rail.addEventListener('transitionend', function(e){
      if(e.propertyName !== 'transform') return;
      normalizeIdx();
      updateDots();
    });

    go(OFFSET, false);
    requestAnimationFrame(function(){ go(idx, false); });
    window.addEventListener('load', function(){ go(idx, false); });
    window.addEventListener('resize', function(){ go(idx, false); });

    var isSwiping = false;

    function nearestIdx(){
      var best = idx, bd = 1e9;
      for(var j = 0; j < slides.length; j++){ var d = Math.abs(centerFor(j) - x); if(d < bd){ bd = d; best = j; } }
      return best;
    }
    function wrapDuringDrag(baseGetter, baseSetter){
      /* ドラッグ中、端に寄りすぎたら1周ぶんワープ（見た目は同じ画像なので継ぎ目なし） */
      var span = loopSpan();
      var maxX = centerFor(OFFSET - 1) + slideStep();
      var minX = centerFor(OFFSET + N) - slideStep();
      if(x > maxX){ x = x - span; baseSetter(baseGetter() - span); setX(x, false); }
      else if(x < minX){ x = x + span; baseSetter(baseGetter() + span); setX(x, false); }
    }

    var tDrag = false, tsx = 0, tsy = 0, tstx = 0, lockDir = 0, tStart = 0;
    rail.addEventListener('touchstart', function(e){
      tDrag = true; tsx = e.touches[0].clientX; tsy = e.touches[0].clientY; tstx = x; lockDir = 0; isSwiping = false; tStart = Date.now();
      rail.style.transition = 'none';
    }, {passive: true});
    rail.addEventListener('touchmove', function(e){
      if(!tDrag) return;
      var dx = e.touches[0].clientX - tsx, dy = e.touches[0].clientY - tsy;
      if(lockDir === 0){
        if(Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 4){ lockDir = 1; rail.classList.add('is-dragging'); }
        else if(Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 4){ lockDir = 2; }
      }
      if(lockDir === 1){
        e.preventDefault();
        isSwiping = true;
        setX(tstx + dx, false);
        wrapDuringDrag(function(){ return tstx; }, function(nv){ tstx = nv; });
      }
    }, {passive: false});
    rail.addEventListener('touchend', function(e){
      if(!tDrag) return; tDrag = false; rail.classList.remove('is-dragging');
      if(lockDir === 1){
        var dx = e.changedTouches[0].clientX - tsx, dt = Date.now() - tStart, v = dt > 0 ? dx / dt : 0;
        idx = nearestIdx();
        var adv = (Math.abs(dx) > slideStep() * 0.25) || (Math.abs(v) > 0.4);
        go(adv ? idx + (dx < 0 ? 1 : -1) : idx, true);
      }
      setTimeout(function(){ isSwiping = false; }, 60);
    });

    var mDrag = false, msx = 0, mstx = 0, mStart = 0;
    rail.addEventListener('dragstart', function(e){ e.preventDefault(); });
    rail.addEventListener('pointerdown', function(e){
      if(e.pointerType !== 'mouse') return; e.preventDefault();
      mDrag = true; msx = e.clientX; mstx = x; isSwiping = false; mStart = Date.now();
      rail.classList.add('is-dragging'); rail.style.transition = 'none';
    });
    window.addEventListener('pointermove', function(e){
      if(!mDrag || e.pointerType !== 'mouse') return;
      var dx = e.clientX - msx;
      if(Math.abs(dx) > 4){ isSwiping = true; }
      setX(mstx + dx, false);
      wrapDuringDrag(function(){ return mstx; }, function(nv){ mstx = nv; });
    });
    window.addEventListener('pointerup', function(e){
      if(!mDrag || e.pointerType !== 'mouse') return; mDrag = false; rail.classList.remove('is-dragging');
      var dx = e.clientX - msx, dt = Date.now() - mStart, v = dt > 0 ? dx / dt : 0;
      idx = nearestIdx();
      var adv = (Math.abs(dx) > slideStep() * 0.25) || (Math.abs(v) > 0.4);
      go(adv ? idx + (dx < 0 ? 1 : -1) : idx, true);
      setTimeout(function(){ isSwiping = false; }, 60);
    });

    rail.addEventListener('click', function(e){ if(isSwiping){ e.preventDefault(); e.stopPropagation(); } }, true);
  }
})();
